import * as React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface DataCardProps {
  label: string;
  value: string | number;
  icon?: LucideIcon;
  iconColor?: string;
  trend?: { value: string; positive?: boolean };
  className?: string;
  onClick?: () => void;
}

export function DataCard({ label, value, icon: Icon, iconColor = 'text-cs-primary-400', trend, className, onClick }: DataCardProps) {
  return (
    <div
      className={cn(
        'bg-cs-surface-card border border-cs-border rounded-lg p-4',
        onClick && 'cursor-pointer hover:border-cs-border-subtle hover:bg-cs-surface-hover transition-colors',
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <p className="text-xs text-cs-text-muted uppercase tracking-wide font-medium">{label}</p>
          <p className="mt-1 text-2xl font-bold text-cs-text-primary tabular-nums">{value}</p>
          {trend && (
            <p className={cn('mt-1 text-xs', trend.positive ? 'text-cs-success-400' : 'text-cs-text-muted')}>
              {trend.value}
            </p>
          )}
        </div>
        {Icon && (
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-cs-surface-raised flex items-center justify-center">
            <Icon className={cn('w-5 h-5', iconColor)} aria-hidden="true" />
          </div>
        )}
      </div>
    </div>
  );
}
